import { computeExportSize } from './exportSize.ts';
import type { MarkupShape } from './markupShapes.ts';
import { drawScene } from './renderMarkup.ts';

const JPEG_TYPE = 'image/jpeg';
const JPEG_QUALITY = 0.9;

function canvasToBlob(canvas: HTMLCanvasElement): Promise<Blob> {
    return new Promise((resolve, reject) => {
        canvas.toBlob(
            (blob) =>
                blob ? resolve(blob) : reject(new Error('The browser could not encode the image.')),
            JPEG_TYPE,
            JPEG_QUALITY
        );
    });
}

export async function exportMarkupJpeg(
    image: ImageBitmap,
    shapes: readonly MarkupShape[]
): Promise<Blob> {
    const size = computeExportSize(image);
    const canvas = document.createElement('canvas');
    canvas.width = size.width;
    canvas.height = size.height;
    const ctx = canvas.getContext('2d');
    if (!ctx) throw new Error('The browser could not create a drawing canvas.');
    ctx.setTransform(size.scale, 0, 0, size.scale, 0, 0);
    drawScene(ctx, image, shapes);
    return canvasToBlob(canvas);
}
